import styles from '../invictusLanding.module.css'
import Elitefaculty from "../../../assets/faculty_icon1.svg";
import JEETraining from "../../../assets/training_icon2.svg";
import Mentorship from "../../../assets/mentorship_icon3.svg";
import Performance from "../../../assets/performance_icon4.svg";
import TestStructure from "../../../assets/test_icon5.svg";
import backImg from '../../../assets/whychoose_pattern.svg'
import { useEffect, useState } from 'react';

const cardData = [
    {
        title: "Map Your Potential",
        description:
            "for National & International Olympiads & JEE Main & Advanced",
        image: Elitefaculty,
        gradient: "linear-gradient(to right, #133162, #3779B8)",
    },
    {
        title: "Benchmark Standing vs ",
        description:
            "India’s Sharpest Minds",
        image: JEETraining,
        gradient: "linear-gradient(139deg, #454381 -5.32%, #A971B8 103.12%)",
    },
    {
        title: "Identify Cognitive Strengths",
        description:
            " and Conceptual Blind Spots",
        image: Mentorship,
        gradient: "linear-gradient(139deg, #368885 -5.32%, #72B970 103.12%)",
    },
    {
        title: "Learn Time Management",
        description:
            "Patterns and Accuracy Heatmaps",
        image: Performance,
        gradient: "linear-gradient(139deg, #94454D -5.32%, #C29DA1 103.12%)",
    },
    {
        title: "Opportunity to Join",
        description:
            "the Most Advanced JEE Pre-Program – Invictus",
        image: TestStructure,
        gradient: "linear-gradient(139deg, #80743C -5.32%, #BAA851 103.12%)",
    },
];

const Card = ({ img, description, title, gradient }) => (
    <div
        className={styles.WhyIat_card}
        style={{ background: gradient }}
    >
        <div className={styles.WhyIat_card_content}>
            <img src={backImg} alt="backimg" className={styles.WhyIat_card_backImg} />
            <h6>{title}</h6>
            <p>
                {description}
            </p>
            <img className={styles.cardImg} src={img} alt={title} />

        </div>
    </div>
)

const WhyIat = () => {

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className={`${styles.WhyIat_container}`}>
            <div className={styles.WhyIat_header_wrapper}>
                <div className={styles.WhyIat_header}>
                    <h1>Why <span>Invictus Ace</span></h1>
                    <p>
                        Your Gateway to the most advanced JEE preparation program
                    </p>
                </div>
            </div>
            <div className={`${styles.WhyIat_card_wrapper} container`}>
                {
                    cardData.map(({ title, description, image, gradient }, index) => (
                        <div
                            style={{ zIndex: index + 2, left: isMobile ? '' : `${(index) * 18}%`, paddingTop: `${(index + 1) * 90}vh` }}
                            className={styles.WhyIat_percard_wrapper}
                        >
                            <div style={{ position: 'sticky', top: isMobile ? index === 0 ? '10rem' : `${(index + 1) * 7}rem` : `${index % 2 === 0 ? "9rem" : '22rem'}` }}>
                                <Card description={description} img={image} title={title} gradient={gradient} />
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default WhyIat